import { api } from "../api";

/**
 * resetUserPasswordById - Function that resets on database the password of an user by id and customer id to the default password
 * /users/{customerId}/{id}/password/reset
 * method PUT
 * @async-function
 */
const resetUserPasswordById = async (token: string, id: number, customerId: number) => {
    const response = await api.put(
        `/users/${customerId}/${id}/password/reset`, {}, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default resetUserPasswordById;
